<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconTranslation_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M6.25 1c.449 0 .818.338.87.772l.005.103v.875H8a.875.875 0 0 1 .102 1.744L8 4.5l-.906.001c-.128 1.76-.635 3.36-1.411 4.584l-.051.078c.7.287 1.549.488 2.491.56l1.702-3.828c.277-.622 1.097-.686 1.485-.192l.063.093.05.099 3.5 7.875a.874.874 0 0 1-1.55.801l-.048-.09-.547-1.231H8.471l-.547 1.23a.875.875 0 0 1-1.059.48l-.095-.036a.875.875 0 0 1-.48-1.059l.035-.095 1.051-2.366c-1.098-.144-2.105-.444-2.95-.869-.745.614-1.61.965-2.551.965a.875.875 0 0 1-.103-1.744l.103-.006a2.1 2.1 0 0 0 1.034-.29c-.656-.663-1.035-1.458-1.034-2.337a.875.875 0 0 1 1.744-.099l.006.102c0 .378.188.755.527 1.103.618-.934 1.06-2.236 1.186-3.728L1.875 4.5a.875.875 0 0 1-.103-1.744l.103-.006h3.5v-.875c0-.483.392-.875.875-.875m2.999 10.5h2.752l-1.376-3.097z"
    />
</svg>
